import { lazyLoad } from 'utils/lazy';

export const Dashboard = lazyLoad(
  () => import('./Dashboard'),
  (m) => m.Dashboard
);
